import { FC, ReactElement } from 'react';

import { Link } from 'react-router-dom';

import { FormImageOption } from '../../entities/@forms/Form/Form';
import { AppRoute, appRoutes } from '../../entities/Routing/Routing';
import { replaceUrlParamKeysWithValues } from '../../helpers/url';
import { useTrans } from '../../hooks';

interface SSRVariantListProps {
    variants: FormImageOption[];
}

export const SSRVariantList: FC<SSRVariantListProps> = ({
    variants,
}): ReactElement => {
    const trans = useTrans();

    return (
        <nav>
            <ul>
                {variants.map(variant => {
                    const slug = variant.value;
                    const productDetailPath = trans(appRoutes[AppRoute.productDetail].path);
                    const productDetailUrl = replaceUrlParamKeysWithValues(productDetailPath, {
                        slug,
                    });

                    return (
                        <li key={slug}>
                            <Link
                                to={productDetailUrl}
                                title={variant.label}
                            />
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};
